import { GrandstreamATAType } from '../grandstream-ata/grandstream-ata.type';
import { ACSATAType } from '../acs-ata/acs-ata.type';
import { AcsFirmwareType } from '../acs-ata/acs-firmware/acs-firmware.type';

export type ATATypeType = {
  id: number;
  brand: string;
  model: string;
  wan_ports: number;
  lan_ports: number;
  fxs_ports: number;
  created_at: string;
  modified_at: string;
  is_potscast: boolean;

  atas?: Array<GrandstreamATAType> | null;
  acs_atas?: Array<ACSATAType> | null;
  acs_ata_firmwares?: Array<AcsFirmwareType> | null;
  mcu_firmwares?: Array<AcsFirmwareType> | null;
  available_commands?: { [key: string]: boolean };
  available_sections?: Array<{ name: string; enabled: boolean }>
};

export enum ACSFirmwareType {
  firmware = 'Firmware',
  mcu = 'MCU',
}